import SidebarView from "./Sidebar.view";
import { LocalStorageService } from "../../services";
import { useEffect, useState } from "react";
function SidebarContainer(props) {
    const logoutFuntion = () => {
        LocalStorageService.clear();
        window.location.href = "/auth";
    };

    const [showDropdown, setShowDropdown] = useState(true);
    const [active, setActive] = useState("");
    const toggleDropDown = () => {
        setShowDropdown(!showDropdown);
    };
    const settingActive = (i) => {
        setActive(i);
    };

    useEffect(() => {
        setActive(document.location.pathname);
    }, [document.location.pathname]);

    return (
        <SidebarView
            navOptions={props.navOptions}
            changeNavOptions={props.changeNavOptions}
            toggleDropDown={toggleDropDown}
            showDropdown={showDropdown}
            settingActive={settingActive}
            active={active}
            logoutFuntion={logoutFuntion}
        />
    );
}

export default SidebarContainer;
